<template>
  <!-- 目录 -->
  <el-menu
    :default-active="activeIndex"
    @select="handleSelect"
    @open="menuOpenHandle"
    @close="menuCloseHandle"
    class="el-menu-vertical"
    background-color="#fff"
    text-color="#333333"
    active-text-color="#0FC29A"
  >
    <template v-for="menu in content">
      <el-submenu
        :key="menu.key"
        v-if="menu.children && menu.children.length > 0"
        :index="menu.key"
        :disabled="menu.isLock"
        :class="menu.isLock ? 'menu-lock' : ''"
      >
        <template slot="title">
          <span>{{ menu.name }}</span>
        </template>
        <subItem :content="menu.children" @getSubItem="onMenuItemClick"></subItem>
        <!-- <el-menu-item
          v-for="item in menu.children"
          :key="item.key"
          :index="item.key"
        >{{ item.name }}</el-menu-item> -->
      </el-submenu>
      <el-menu-item
        :key="menu.key"
        v-else
        :index="menu.key"
        :disabled="menu.isLock"
        :class="menu.isLock ? 'menu-lock' : ''"
      >{{ menu.name }}</el-menu-item>
    </template>
  </el-menu>
</template>
<script>
  import subItem from './subItem.vue';
  export default {
    name: "NavBar",
    components: {
      subItem,
    },
    props: {
      content: {
        type: Array,
        default: () => {
          return [];
        }
      }
    },
    data() {
      return {
        activeIndex: "introduction"
      }
    },
    methods: {
      onMenuItemClick(item) {
        console.log(item)
      },
      handleSelect(index) {
        this.$emit('chapterChange', index);
      },
      changeActiveIndex(activeIndex) {
        if(this.activeIndex === activeIndex) return;
        this.activeIndex = activeIndex;
      },


      menuOpenHandle(index) {
        // this.handleSelect(index)
      },
      menuCloseHandle(index) {
        // this.handleSelect(index)
      },
      // 导航滚动定位
      // handleSelect(index) {
      //   // 假设index的格式是'1-1'这样的，代表一级菜单下的某个子菜单
      //   this.$emit('custom-event');
      //   this.scrollToElement(index);
      // },
      // scrollToElement(index) {
      //   const element = document.getElementById(`${index}`);
      //   if (element) {
      //     element.scrollIntoView({behavior: 'smooth'}); // 平滑滚动
      //   }
      // },
    }
  }
</script>

<style lang="scss" scoped>
/deep/.el-submenu.menu-lock.is-disabled{
  position: relative;

  .el-submenu__title{
    padding-right: 55rem;
    opacity: 1;
  }

  &:after{
    content: '';
    width: 30rem;
    height: 30rem;
    position: absolute;
    top: 50%;
    margin-top: -15rem;
    right: 80rem;
    background: url("~@/assets/images/common/lock.png") center center no-repeat;
    background-size: contain;
    cursor: not-allowed;
  }
}
/deep/.el-menu-item.menu-lock.is-disabled{
  position: relative;

  &:after{
    content: '';
    width: 30rem;
    height: 30rem;
    position: absolute;
    top: 50%;
    margin-top: -15rem;
    right: 40rem;
    background: url("~@/assets/images/common/lock.png") center center no-repeat;
    background-size: contain;
    cursor: not-allowed;
  }
}
/deep/.el-menu-vertical{

  .el-menu-item{
    height: 72rem;
    line-height: 72rem;
    font-size: 26rem;
    color: #515151;
  }

  .el-submenu{
    
    .el-menu-item{
      height: 72rem;
      line-height: 72rem;
      font-size: 26rem;
      color: #515151;
    }
  }
}

/deep/.el-menu-item:hover{
  background-color: #f7f7f7 !important;
}
/deep/.el-menu-item:focus{
  background-color: #fff !important;
}
/deep/.el-submenu__title:hover{
  background-color: #f7f7f7 !important;
}
/deep/.el-menu-item,/deep/.el-submenu__title{
  height: 72rem;
  line-height: 72rem;
  font-size: 28rem;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}
/deep/.el-submenu .el-menu-item{
  height: 72rem;
  line-height: 72rem;
  font-size: 28rem;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}
</style>
